import * as types from './types'
import { ILicense } from '@cbgms/api'
import { AnyAction } from 'redux'

const defaultCompanyState = {}

export const company = (state: any = defaultCompanyState, action: AnyAction) => {
  switch (action.type) {
    case types.GET_COMPANY_SUCCESS:
      return action.payload.data.Data
    case types.RESET_COMPANY_STATE:
      return defaultCompanyState
    default:
      return state
  }
}

const defaultLicenseValue = null

export const license = (state: ILicense | null = defaultLicenseValue, action: AnyAction) => {
  switch (action.type) {
    case types.GET_COMPANY_LICENSE_SUCCESS:
      return action.payload.data.Data
    case types.RESET_COMPANY_LICENSE_STATE:
      return defaultLicenseValue
    default:
      return state
  }
}
